const alert = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 14"><path d="M14.69 13.5H8l-6.73-.04A.31.31 0 0 1 1 13l3.4-6.17L7.73.66a.31.31 0 0 1 .54 0l3.33 6.17L15 13a.31.31 0 0 1-.31.5m-5.94-3.21h-1.5v1.5h1.5zm0-5.48h-1.5V9.3h1.5z" clip-rule="evenodd"/></svg>',
};

export { alert as default };
